import { DiscountCodeTheme } from "@acin.reactjs/acin-ui/discountCode";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { AppMediaQueries } from "./BreakpointsTheme";

const discountCodeTheme: ComponentCSSStyle<DiscountCodeTheme> = {
  dropdown: {
    form: {
      input: {
        container: {
          [AppMediaQueries.maxMobile]: {
            minHeight: "40px",
          },
        },
      },

      button: {
        root: {
          [AppMediaQueries.maxMobile]: {
            minHeight: "40px",
          },
        },
      },
    },
  },
};

export default discountCodeTheme;
